/**
   * MR.POINTの表示位置調整
   *
   =============================================================*/
  //  function pointDisplayInit(){
  //   const point_section = document.querySelector('.mrpoint-customer__point-value');
  //   console.log({point_section})
  //   if(!point_section) return;


  //   const point_text = point_section.textContent;
  //   document.getElementById('header-point').textContent = point_text;

  // }

function pointDisplayInit() {
  const point_section = document.querySelector('.mrpoint-customer__point-value');
  console.log('point_section:', point_section);

  if (!point_section) return;

  const point_text = point_section.textContent;

  const headerPoint = document.getElementById('header-point');
  console.log('headerPoint:', headerPoint);

  if (headerPoint) {
    headerPoint.textContent = point_text;
  }
}
  window.addEventListener('load',()=>{
    setTimeout(pointDisplayInit, 500);
  })
// モーダル閉じる記述
// document.addEventListener('click', function (event) {
//     if (event.target.matches('[data-js-close]') || event.target.closest('[data-js-close]')) {
//         let modal = event.target.closest('.modal');
//         if (modal) {
//             modal.style.visibility = 'hidden';
//             modal.style.opacity = '0';
//             modal.style.pointerEvents = 'none';
//         }
//     }
// });
// document.addEventListener('click', function (event) {
//     // モーダルを閉じる処理
//     if (event.target.matches('[data-js-close]') || event.target.closest('[data-js-close]')) {
//         let modal = event.target.closest('.modal');
//         if (modal) {
//             modal.style.opacity = '0';
//             modal.style.visibility = 'hidden';
//             modal.style.pointerEvents = 'none';

//             // 100ms 遅延させて `overflow: hidden;` を解除
//             setTimeout(() => {
//                 document.body.classList.remove('modal-opened'); // ← クラスを削除
//                 document.body.classList.remove('sidebar-opened'); // ← サイドバーも解除
//                 document.body.style.overflow = '';
//                 document.body.style.position = '';
//                 document.body.style.top = '';
//                 document.body.style.setProperty('overflow', '', 'important'); // `!important` の影響も解除
//             }, 100);
//         }
//     }

//     // モーダルを開く処理
//     if (event.target.matches('[data-js-open]') || event.target.closest('[data-js-open]')) {
//         let modalId = event.target.getAttribute('data-js-open');
//         let modal = document.getElementById(modalId);
//         if (modal) {
//             modal.style.opacity = '1';
//             modal.style.visibility = 'visible';
//             modal.style.pointerEvents = 'auto';

//             // `modal-opened` クラスを追加してスクロールを無効化
//             document.body.classList.add('modal-opened');
//             document.body.style.overflow = 'hidden';
//             document.body.style.position = 'fixed';
//             document.body.style.top = '0';
//         }
//     }
// });
// モーダル閉じる記述
document.addEventListener('click', function (event) {
    const closeBtn = event.target.closest('[data-js-close]');
    const openBtn = event.target.closest('[data-js-open]');

    if (closeBtn) {
        const modal = closeBtn.closest('.modal');
        if (modal) closeModal(modal);
    }

    if (openBtn) {
        const modalId = openBtn.getAttribute('data-js-open');
        const modal = document.getElementById(modalId);
        if (modal) openModal(modal);
    }
});

function openModal(modal) {
    modal.style.opacity = '1';
    modal.style.visibility = 'visible';
    modal.style.pointerEvents = 'auto';
    modal.style.display = 'block'; // ← 追加
    document.body.classList.add('modal-opened');
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '0';
}

function closeModal(modal) {
    modal.style.opacity = '0';
    modal.style.visibility = 'hidden';
    modal.style.pointerEvents = 'none';
    
    // 一定時間後に `display: none;` にする
    setTimeout(() => {
        modal.style.display = 'none'; // ← 追加
        removeModalStyles();
    }, 100);
}

function removeModalStyles() {
    document.body.classList.remove('modal-opened', 'sidebar-opened');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.setProperty('overflow', '', 'important');
}

